// extracted by mini-css-extract-plugin
export default {"scroll_btn_wrapper":"ScrollToTop_scroll_btn_wrapper__0zM+Z","progress_ring":"ScrollToTop_progress_ring__TCTe+","scroll_to_top_btn":"ScrollToTop_scroll_to_top_btn__zxckx"};